<ng-container [ngSwitch]="selectedComponent">
  <div *ngSwitchCase="'text'">
    <app-entity-property-text
      [property]="entity.Properties[propertyType.Key]"
      [propertyType]="propertyType"
      [entityForm]="entityForm"
      [entityId]="entity.Id"
      [placeholder]="placeholder"
      (changed)="propertyChange.emit($event)"
    >
    </app-entity-property-text>
  </div>
  <div *ngSwitchCase="'select'">
    <app-entity-property-select
      [property]="entity.Properties[propertyType.Key]"
      [propertyType]="propertyType"
      [entityForm]="entityForm"
      [entityId]="entity.Id"
      [placeholder]="placeholder"
      (changed)="propertyChange.emit($event)"
    >
    </app-entity-property-select>
  </div>
  <div *ngSwitchCase="'numeric'">
    <app-entity-property-numeric
      [property]="entity.Properties[propertyType.Key]"
      [propertyType]="propertyType"
      [entityForm]="entityForm"
      [entityId]="entity.Id"
      [placeholder]="placeholder"
      (changed)="propertyChange.emit($event)"
    ></app-entity-property-numeric>
  </div>
  <div *ngSwitchCase="'checkbox'">
    <app-entity-property-checkbox
      [property]="entity.Properties[propertyType.Key]"
      [propertyType]="propertyType"
      [entityForm]="entityForm"
      [entityId]="entity.Id"
      (changed)="propertyChange.emit($event)"
    ></app-entity-property-checkbox>
  </div>
  <div *ngSwitchCase="'boolean-button'">
    <app-entity-property-boolean-button
      [property]="entity.Properties[propertyType.Key]"
      [propertyType]="propertyType"
      [entityForm]="entityForm"
      [entityId]="entity.Id"
      (changed)="propertyChange.emit($event)"
    ></app-entity-property-boolean-button>
  </div>
  <div *ngSwitchCase="'button'">
    <app-entity-property-button
      [property]="entity.Properties[propertyType.Key]"
      [propertyType]="propertyType"
      [entityForm]="entityForm"
      [entityId]="entity.Id"
      (changed)="propertyChange.emit($event)"
    ></app-entity-property-button>
  </div>
  <div *ngSwitchCase="'password'">
    <app-entity-property-password
      [property]="entity.Properties[propertyType.Key]"
      [propertyType]="propertyType"
      [entityForm]="entityForm"
      [entityId]="entity.Id"
      [placeholder]="placeholder"
      (changed)="propertyChange.emit($event)"
    ></app-entity-property-password>
  </div>
  <div *ngSwitchCase="'textbox'">
    <app-entity-property-textbox
      [property]="entity.Properties[propertyType.Key]"
      [propertyType]="propertyType"
      [entityForm]="entityForm"
      [entityId]="entity.Id"
      [placeholder]="placeholder"
      (changed)="propertyChange.emit($event)"
    ></app-entity-property-textbox>
  </div>
  <div *ngSwitchCase="'datepicker'">
    <app-entity-property-datepicker
      [property]="entity.Properties[propertyType.Key]"
      [propertyType]="propertyType"
      [entityForm]="entityForm"
      [entityId]="entity.Id"
      [placeholder]="placeholder"
      (changed)="propertyChange.emit($event)"
    ></app-entity-property-datepicker>
  </div>
  <div *ngSwitchDefault>Unimplemented field type '{{ propertyType.Key }} / {{ propertyType.ValueType }}'</div>
</ng-container>
